
module.exports = function($){

	$.times = function(count, callback){
		var i = count;
		while(i--){
			callback(count - i);
		}
	};

	$.randomFrom = function(list){
		var i = Math.floor(Math.random() * list.length);
		return list[i];
	};

	$.clipboard = function(str){
		var el = $("<textarea>"),
			r = false;

		el.val(str)
		.css({
			position: "fixed",
			left: "-100%",
			top: 0
		})
		.appendTo("body")
		.select();
		r = document.execCommand("copy");
		el.remove();

		return r;
	};

	$.preventDefault = function(e){
		e.preventDefault();
	};

};



// WEBPACK FOOTER //
// ./src/js/extend/jquery.js